import PropTypes from "prop-types";
import "./styles.css";

function Button({ style, title, onPress, blocked }) {
  return (
    <button
      type="button"
      style={style}
      className={blocked ? "blockedButton" : "primaryButton"}
      onClick={onPress}
      disabled={blocked}
    >
      {title}
    </button>
  );
}

Button.propTypes = {
  blocked: PropTypes.bool,
  onPress: PropTypes.func.isRequired,
  style: PropTypes.oneOfType([PropTypes.object]).isRequired,
  title: PropTypes.string.isRequired,
};

Button.defaultProps = {
  blocked: false,
};

export { Button };
